import React from 'react'

function Genres() {
    return (
        <div className='genres'>
            
        </div>
    )
}

export default Genres